import React from "react";
import "./Sidebar.scss";

import Logo from "../assets/lumus.svg";
import { Cross, X } from "lucide-react";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const sidebaroptions = [
    { title: "Home", url: "/" },
    { title: "About Us", url: "/about-us" },
    { title: "Privacy Policy", url: "/privacy-policies" },
    { title: "Terms and Condition", url: "/terms-and-condition" },
  ];

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo-wrapper">
        <img src={Logo} alt="logo" />
        <h2>LUMUS</h2>
        </div>
  
        <X className="close-icon" onClick={onClose} />
    
      </div>
      <ul className="sidebar-menu">
        {sidebaroptions.map((item, index) => (
          <li key={index}>
            <a href={item.url}>{item.title}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
